import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
let default_1 = class extends Vue {
    isTheme = false;
    themName = localStorage.getItem('themName');
    list = [
        {
            status: 'Critical',
            name: 'If Task Name Is To...',
        },
        {
            status: 'Major',
            name: 'If Task Name Is To...',
        },
        {
            status: 'Minor',
            name: 'If Task Name Is To...',
        },
    ];
    changTheme() {
        if (this.isTheme) {
            document.body.setAttribute('data-theme', 'dark');
        }
        else {
            document.body.setAttribute('data-theme', 'light');
        }
    }
    init() {
        this.themName = localStorage.getItem('themName') || 'light';
        if (this.themName === 'light') {
            document.body.setAttribute('data-theme', 'light');
        }
        else if (this.themName === 'dark') {
            document.body.setAttribute('data-theme', 'dark');
        }
    }
    mounted() {
        this.init();
    }
};
default_1 = __decorate([
    Component({
        name: 'privacyMode',
        components: { SecondaryVerification },
        i18n: {
            messages: {
                'en-us': {
                    privacy: 'Privacy Mode:',
                    activated: 'Activated',
                    closed: 'Closed',
                },
                zh: {
                    privacy: '黑色主题：',
                    activated: '开启',
                    closed: '关闭',
                },
            },
        },
    })
], default_1);
export default default_1;
